/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Notes_Reply_Complete_LabelInputs */



/**
* | output |
* | --- |
* | "Reply Complete" |
*
* @param {Event_Notes_Reply_Complete_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_notes_reply_complete_label = /** @type {((inputs?: Event_Notes_Reply_Complete_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Notes_Reply_Complete_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Reponse completee")
	if (locale === "de") return /** @type {LocalizedString} */ ("Antwort abgeschlossen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Risposta completa")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ответ завершен")
	if (locale === "es") return /** @type {LocalizedString} */ ("Respuesta completa")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("回复完成")
	if (locale === "ja") return /** @type {LocalizedString} */ ("返信完了")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उत्तर पूरा हुआ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Resposta concluída")
	return /** @type {LocalizedString} */ ("Reply Complete")
});